import React from 'react';
import { translate } from 'react-i18next';

import TimeSheetLocationNav from 'components/timesheets/TimeSheetLocationNav.js';
import TimeSheetItem from 'components/timesheets/TimeSheetItem.js';

class TimeSheetPreview extends React.Component {
  constructor(props) {
    super(props);
    this._onApprove = this._onApprove.bind(this);
    this._viewDetails = this._viewDetails.bind(this);

    this.state = {
      accordionOpen: !(!this.props.showHeader || this.props.showHeader == false),
    };
  }

  _onApprove(e) {
    if (!_.isEmpty(this.props.data.punch_ids)) {
      this.props.onApprovePunches(this.props.data.punch_ids);
    }
  }

  _viewDetails(e) {
    this.setState({
      accordionOpen: !this.state.accordionOpen,
    });
  }

  _renderNoTimesheetNotice(data, currentLocationName, breakPunchesEnabled) {
    if (data && data.punch_ids) {
      return data.punch_ids.map((punch, index) => (
        <TimeSheetItem
          data={TimeSheetStore.getPunchById(punch)}
          currentLocation={currentLocationName}
          displayBreakPunches={breakPunchesEnabled}
          key={index}
        />
      ));
    }
  }

  render() {
    if (!this.props.shouldRender) {
      return false;
    }

    const { data, type, currentLocation } = this.props;
    const currentLocationName = !_.isEmpty(currentLocation) ? ` ${currentLocation.name} ` : ' ';
    const breakPunchesEnabled = currentLocation.paid_breaks
      || currentLocation.unpaid_break_type == 'manual'
      || TimeSheetStore.break_punches.length > 0;
    const start = (data != null && data.starts_at) || '';
    const end = (data != null && data.ends_at) || '';
    const duration = (data != null && data.total_work_duration) || 0;
    const approveDisabled = !data.approvable ? 'disabled' : '';

    const accordionClass = this.state.accordionOpen ? 'accordion open' : 'accordion closed';
    const accordionLabel = this.state.accordionOpen ? this.props.t('TimeSheetPreview.hide_details') : this.props.t('TimeSheetPreview.view_details');
    const toggleClass = this.state.accordionOpen
      ? 'button button--link view-details open'
      : 'button button--link view-details closed';

    return (
      <div className={`${this.props.type} ${this.props.activeState}`}>
        <header>
          <div className="timesheet-meta-data">
            {this.props.showHeader == true && (
              <h1>
                {this.props.t('TimeSheetPreview.current')}
                {currentLocationName}
                {' '}
                {this.props.t('TimeSheetPreview.timesheet')}
              </h1>
            )}
            <p className="sheet-range">
              {['en', 'en_ca'].includes(Utils.getLocale())
                ? moment(start).tz(Utils.getCoreUser().inferred_time_zone).format('MMMM D')
                : moment(start).tz(Utils.getCoreUser().inferred_time_zone).format('D MMMM')
              }
              {' - '}
              {['en', 'en_ca'].includes(Utils.getLocale())
                ? moment(end).tz(Utils.getCoreUser().inferred_time_zone).format('MMMM D, YYYY')
                : moment(end).tz(Utils.getCoreUser().inferred_time_zone).format('D MMMM YYYY').replace(/\./g, '')
              }
              <br />
              {this.props.t('TimeSheetPreview.total_hours_worked')}:
              {' '}
              {Utils.getLocale() === 'fr' 
                ? (Math.round(duration) / 3600).toLocaleString('fr', { minimumFractionDigits: 2 })
                : (Math.round(duration) / 3600).toFixed(2)
              }
              <br />
            </p>

            <button
              className="button button--recommended button--inline"
              onClick={this._onApprove}
              disabled={approveDisabled}
            >
              {this.props.t('TimeSheetPreview.approve_this_timesheet')}
            </button>

            {this.props.showHeader == false && (
              <button className={toggleClass} onClick={this._viewDetails}>
                {accordionLabel}
              </button>
            )}
          </div>
          {this.props.showHeader == true && (
            <TimeSheetLocationNav
              locations={this.props.locations}
              currentLocation={this.props.currentLocation}
              onLocationChange={this.props.onLocationChange}
            />
          )}
        </header>
        <section className={accordionClass}>
          {this._renderNoTimesheetNotice(this.props.data, currentLocationName, breakPunchesEnabled)}
        </section>
      </div>
    );
  }
}

export default translate()(TimeSheetPreview);
